import { useHistory } from "react-router-dom";
import { useCallback, useMemo } from "react";
import queryString from "query-string";
import { useObservable } from "micro-observables";
import { useSelector } from "react-redux";
import cloneDeep from "lodash/fp/cloneDeep";

import { useSearchParams } from "../../../../../hooks/searchParams";
import { ROUTES_MAP } from "../../../../../routes/constants";
import { CONFIG_MANAGER_LIGHT_STEPS } from "../../../index";
import { currentBlockSelector, updateConfigDataRequest } from "../services/stepThree";
import { configDataSelector, scrapeTaskSelector } from "../../../services/general/selectors";

const useFooterActions = () => {
    const history = useHistory();
    const searchParams = useSearchParams();
    const config = useSelector(configDataSelector);
    const task = useSelector(scrapeTaskSelector);
    const templateCode = task?.actual_template_code;
    const blockSelector = useObservable(currentBlockSelector);

    const handleClickPrevState = useCallback(
        () => {
            history.push(
                `${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.two}?${queryString.stringify(searchParams)}`
            );
        },
        [ history, searchParams ]
    );

    const handleClickNextState = useCallback(
        () => {
            history.push(
                `${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.four}?${queryString.stringify(searchParams)}`
            );
        },
        [ history, searchParams ]
    );

    const handleClickSave = useCallback(
        async () => {
            const initialConfig = cloneDeep(config);

            initialConfig.templates = initialConfig.templates.map((template) => {
                if(template.code === templateCode) {
                    const newTemplate = { ...template };

                    if(template.block_selectors.length === 0) {
                        newTemplate.block_selectors.push(blockSelector);
                    } else {
                        const blockSelectorName = blockSelector.name;

                        newTemplate.block_selectors = template.block_selectors.map((item) => {
                            if(item.name === blockSelectorName) {
                                return blockSelector;
                            }

                            return item;
                        });
                    }

                    return newTemplate;
                }

                return template;
            });

            await updateConfigDataRequest({ id: initialConfig.id, initialConfig });
        },
        [ blockSelector, config, templateCode ]
    );

    return useMemo(
        () => ({
            handleClickPrevState,
            handleClickNextState,
            handleClickSave
        }),
        [ handleClickNextState, handleClickPrevState, handleClickSave ]
    );
};

export default useFooterActions;
